import { Box, Flex } from '@npco/zeller-design-system'

import { AddLink } from './AddLink'
import { StyledImagesTitle } from './Images.styled'
import { Image } from './Images.types'
import { ImagesDisplay } from './ImagesDisplay/ImagesDisplay'

interface Props {
  title: React.ReactNode
  onAdd: () => void
  placeholder: string
  images: Image[]
  isLoadingImages?: boolean
  isDownloadingFiles?: boolean
  className?: string
  onClickThumbnail?: (id: string) => void
  thumbnailSize?: number
}

export const Images = ({
  className,
  images,
  isDownloadingFiles,
  isLoadingImages,
  onAdd,
  onClickThumbnail,
  placeholder,
  thumbnailSize,
  title,
}: Props) => {
  return (
    <Box className={className} mb="2.5rem">
      <Flex justifyContent="space-between" alignItems="center">
        <StyledImagesTitle>{title}</StyledImagesTitle>
        <AddLink
          onClick={onAdd}
          isDisabled={isLoadingImages || isDownloadingFiles}
          dataTestId="add-image"
        />
      </Flex>
      <ImagesDisplay
        images={images}
        placeholder={placeholder}
        onClickThumbnail={onClickThumbnail}
        thumbnailSize={thumbnailSize}
        isLoadingImages={isLoadingImages}
        isDownloadingFiles={isDownloadingFiles}
      />
    </Box>
  )
}
